export default __webpack_public_path__ + "static/logo-12-ea6448ad4c773cfee4c01a74bbb834e5.png";